export default __webpack_public_path__ + "static/media/UCityProWeb-Bold.efd4566d.woff2";